// Ref: https://github.com/szimek/signature_pad

const signaturePadList = {};
Core.SignaturePad = function (fileUploadObjList) {
  // Adjust canvas coordinate space taking into account pixel ratio,
  // to make it look crisp on mobile devices.
  // This also causes canvas to be cleared.
  function resizeCanvas(canvas, signaturePad) {
    // When zoomed out to less than 100%, for some very strange reason,
    // some browsers report devicePixelRatio as less than 1
    // and only part of the canvas is cleared then.
    const ratio = Math.max(window.devicePixelRatio || 1, 1);

    // This part causes the canvas to be cleared
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);

    // This library does not listen for canvas changes, so after the canvas is automatically
    // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
    // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
    // that the state of this library is consistent with visual state of the canvas, you
    // have to clear it manually.
    //signaturePad.clear();

    // If you want to keep the drawing on resize instead of clearing it you can reset the data.
    signaturePad.fromData(signaturePad.toData());
  }

  function save(dataURL, fileName, $prevFile, fileUploadObj, $fileUploadEl) {
    const blob = dataURLToBlob(dataURL);
    const imageFile = new File([blob], fileName);
    const $list = $fileUploadEl.find('.fileUpload-fileList');
    const fileCount = $list.find('.fileUpload-file').length || 0;
    
    fileUploadObj.uploadFile(imageFile, fileCount, function(resp, fileEl) {
      // success callback      
      if ($prevFile) {
        // delete previous signature
        deleteSignature($prevFile);
      }
    }, function(error) {
      // fail callback
      console.error('Fail to upload', {error, fileName});
    }, true);
  }

  function deleteSignature($prevFile) {
    var $btn = $prevFile.find('.fileUpload-delete');
      if ($btn) {
          $btn.trigger('click');
      }
  }

  function dataURLToBlob(dataURL) {
    // Code taken from https://github.com/ebidel/filer.js
    const parts = dataURL.split(";base64,");
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  }

  function initSignaturePad(el) {
    const wrapper = el.closest(".signaturePad-wrapper");
    const canvasEl = el.querySelector("canvas");
    const clearButton = el.querySelector("[data-action=clear]");
    const savePNGButton = el.querySelector("[data-action=save-png]");
    const dateInput = wrapper.querySelector(".signaturePad-dateInput");
    const error = wrapper.querySelector(".signaturePad-error");
    const fileName = wrapper.dataset.fileName;
    const fileUrlEl = wrapper.querySelector(".signaturePad-fileUrl");
    const fileUploadEl = wrapper.querySelector(".fileUpload");
    const fileUploadObj = fileUploadObjList[fileUploadEl.id];

    fileUploadObj.onDeleteSuccess = function() {
      const uploadClass = fileUploadEl.getAttribute('data-upload-class');
      const fileNameClass = fileUploadEl.getAttribute('data-original-file-name-class');

      // reset name attribute to 0 index
      fileUploadEl.querySelector(`.${uploadClass}`).setAttribute('name', `${uploadClass}[0]`);
      fileUploadEl.querySelector(`.${fileNameClass}`).setAttribute('name', `${fileNameClass}[0]`);
    };

    const signaturePadObj = new SignaturePad(canvasEl, {
        height: 200,
    });
    signaturePadList[fileName] = signaturePadObj;

    window.onresize = function () {
      resizeCanvas(canvasEl, signaturePadObj);
    };
    resizeCanvas(canvasEl, signaturePadObj);

    clearButton && clearButton.addEventListener("click", () => {
      signaturePadObj.clear();

      // check if there's a previous signature, trigger delete
      const $list = $(fileUploadEl).find('.fileUpload-fileList');
      const items = $list.find('.fileUpload-filename');
      if (items.length  > 0) {
        $(items).each(function(i, item) {
            var name = $(item).text();
            if ((name.includes(fileName))) {
              var $file = $(item).closest('.fileUpload-file');
              deleteSignature($file);
            }
        });  
      }
    });

    savePNGButton && savePNGButton.addEventListener("click", (e) => {
      savePNGButton.classList.remove("pulse");
      const dateVal = dateInput.value;
      const dateObj = moment(dateVal, "DD/MM/YYYY");
      const $list = $(fileUploadEl).find('.fileUpload-fileList');
      const items = $list.find('.fileUpload-filename');

      error.innerText = "";
      if (signaturePadObj.isEmpty()) {
        error.innerText = "Please provide a signature";
        return;
      }

      if (!dateVal) {
        error.innerText = "Please select date";
        return;
      }

      if (dateVal && !dateObj.isValid()) {
        error.innerText = "Invalid date format";
        return;
      }

      // check if signature already exist
      let $prevFile = null;
      if (items.length  > 0) {
        $(items).each(function(i, item) {
            var name = $(item).text();
            if ((name.includes(fileName))) {
              $prevFile = $(item).closest('.fileUpload-file');
              // error.innerText = "Signature already exist";
            }
        });  
      }

      const dataURL = signaturePadObj.toDataURL();
      save(dataURL, `${fileName}_${dateObj.format("DDMMYYYY")}.png`, $prevFile, fileUploadObj, $(fileUploadEl));
    });
    
    if (fileUrlEl && fileUrlEl.value) {
      signaturePadObj.fromDataURL(fileUrlEl.value);
    }
  }

  function scrollToUploadEl() {
    document
      .getElementById("checkoutHomeModification-fileupload")
      .scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
  }

  function init() {
    const signaturePadElements = document.querySelectorAll(".signaturePad");    
    signaturePadElements.forEach((el) => {
      initSignaturePad(el);
    });
  }

  var publicAPI = {
    init: init,
  };

  return publicAPI;
};
